import jQuery from 'jquery';
import autosize from 'autosize';
import * as segmentio from 'rp-analytics';
import rpBreakpoints, { breakpointCodes } from 'rp-mq-breakpoints';
import deviceDetect from './../deviceDetect';
import cardPage from './../cardPage';

const defaultConfig = {
    switcherActiveClass: 'ui-slider__label--active',
    bookieSwitcher: '.js-RC-customizeSettings__switcher',
    bookieSwitcherItem: '.js-RC-customizeSettings__switcherItem',
    activeBookieClass: 'RC-customizeSettings__switcherItem_active',
    popoverActiveClass: 'RC-customizeSettings_active',
    popoverMobileClass: 'RC-customizeSettings_mobile',
    settingsButtonDisabledClass: 'RC-runnerButtons__item_disabled',
    runnerRowSelector: '.RC-runnerRow',
    nonRunnerClass: 'js-runnerNonRunner',
    excludedRunnerClass: 'js-runnerExcludedRunner',
    switcherInactiveClass: 'RC-customizeSettings__popoverItem_inactive',
    stateData: {
        form: false,
        myNotes: false,
        spotlights: false,
        comments: false,
        raceConditions: false,
        owner: false,
        quotes: false,
        pedigrees: false,
        rtf: true,
        priceHistory: true,
        decimalOdds: false,
        bettingForecast: true,
        orderByPrice: true,
        myRatings: false,
        showPrices: true,
    },
    lastChangedOption: '',
};
export default class CustomizeSettings {
    constructor(customizeSettingsConfig) {
        this.$popover = jQuery('.js-RC-customizeSettings');
        this.isPhone = deviceDetect.phone();
        if (this.isPhone) {
            this.config = jQuery.extend(true, defaultConfig, {
                stateData: {
                    orderByPrice: true
                },
            }, customizeSettingsConfig);
        } else {
            this.config = jQuery.extend(true, defaultConfig, customizeSettingsConfig);
        }
        this.$settingsBookieSwitcher = jQuery(this.config.bookieSwitcher);
        this.bindEvents();
        if (this.config.onInit instanceof Function) {
            this.config.onInit(this);
        }
        if (jQuery.cookie('chooseBookie')) {
            this.changeBookieSwitcherUI(jQuery.cookie('chooseBookie'));
        }
    }

    bindEvents() {
        function switchOption(element, event) {
            this.config.lastChangedOption = this.config[element].displayName;
            this.switchHandler(event.target, this.config[element]);
        }

        Object.keys(this.config).forEach((element) => {
            const $switcherElement = jQuery(this.config[element].switcherSelector);
            if ($switcherElement.length) {
                $switcherElement
                    .on('change', switchOption.bind(this, element));
            }
        });

        function changeBookmaker(event) {
            const feedName = jQuery(event.target)
                .closest(this.config.bookieSwitcherItem).attr('data-feed');
            this.changeBookieSwitcherUI(feedName);
            jQuery.cookie('chooseBookie', feedName, {
                domain: `.${location.host.split('.').slice(1).join('.')}`,
                path: '/',
                expires: 365
            });
            jQuery.event.trigger('bookieChanged.BOOKMAKER', feedName);
        }

        if (this.$settingsBookieSwitcher) {
            this.$settingsBookieSwitcher.on('click', changeBookmaker.bind(this));
        }

        jQuery(document).on('bookieChanged.BOOKMAKER', (event, feedName) => {
            this.changeBookieSwitcherUI(feedName);
        });
        jQuery(document).on('popoverOpenedSettings', this.mobileHandler.bind(this));
        jQuery(document).on('popoverClosedSettings', cardPage.addScroll);
        jQuery(document).on('dynamicPricesUpdated.PRICES', this.dynamicPricesUpdated.bind(this));

        if (!this.isPhone) {
            jQuery(window).on('rpBreakpointsSwitch', this.switchBreakpointsHandler.bind(this));
        }
    }

    mobileHandler() {
        const isSmallBreakpoint = [breakpointCodes.EXTRA_NARROW, breakpointCodes.NARROW]
            .includes(rpBreakpoints.current().code);
        if (!this.isPhone && !isSmallBreakpoint) {
            return;
        }
        if (this.isPhone) {
            this.$popover.addClass(this.config.popoverMobileClass);
            cardPage.removeScroll();
        } else {
            cardPage.removeScroll();
        }
    }

    switchBreakpointsHandler(event) {
        const bigBreakpoints = [
            breakpointCodes.MEDIUM,
            breakpointCodes.WIDE,
            breakpointCodes.EXTRA_WIDE
        ];
        const smallBreakpoints = [
            breakpointCodes.EXTRA_NARROW,
            breakpointCodes.NARROW
        ];
        const newBreakpoint = event.detail.breakpoint.code;
        const previousBreakpoint = event.detail.breakpointPrevious.code;
        if (this.$popover.hasClass(this.config.popoverActiveClass)) {
            const isSwitchToBigBreakpoint = bigBreakpoints.includes(newBreakpoint)
                && smallBreakpoints.includes(previousBreakpoint);
            const isSwitchToSmallBreakpoint = smallBreakpoints.includes(newBreakpoint)
                && bigBreakpoints.includes(previousBreakpoint);
            if (isSwitchToBigBreakpoint) {
                cardPage.addScroll();
            } else if (isSwitchToSmallBreakpoint) {
                cardPage.removeScroll();
            }
        }
    }

    changeBookieSwitcherUI(feedName) {
        if (!feedName) {
            return;
        }
        const bookmakerBtn = document
            .querySelector(`.js-RC-customizeSettings__switcher [data-feed="${feedName}"]`);
        const activeBtn = document.querySelector(`.${this.config.activeBookieClass}`);

        if (activeBtn) {
            activeBtn.classList.remove(this.config.activeBookieClass);
        }
        if (bookmakerBtn) {
            bookmakerBtn.classList.add(this.config.activeBookieClass);
        }
    }

    switchHandler(target, config) {
        const priceHistory = jQuery(this.config.priceHistory.switcherSelector);
        const isActiveTarget = !jQuery(target)
            .closest('li')
            .hasClass(this.config.switcherInactiveClass);
        if (jQuery(target).is(':checked')) {
            this.show(config);
            if (config.name === 'showPrices') {
                priceHistory.attr('disabled', false);
                if (isActiveTarget) {
                    priceHistory
                        .closest('li')
                        .removeClass(this.config.switcherInactiveClass);
                }
                if (jQuery(priceHistory).is(':checked')) {
                    this.show(this.config.priceHistory);
                }
            }
        } else {
            this.hide(config);
            if (config.name === 'showPrices') {
                if (this.config.stateData.priceHistory) {
                    this.hide(this.config.priceHistory);
                }
                priceHistory
                    .attr('disabled', true);
                if (isActiveTarget) {
                    priceHistory
                        .closest('li')
                        .addClass(this.config.switcherInactiveClass);
                }
            }
        }
        this.trackCardCustomisation(this.config.stateData);
    }

    show(config) {
        const state = true;
        this.changeSwitcherState(config, state);
        this.switchHiglightButtonOnCard(config, state);
        this.switchContent(config, state);
        this.config.stateData[config.name] = state;
        this.publishSettingsData();
        if (this.config.onShow instanceof Function) {
            this.config.onShow(this);
        }
    }

    hide(config) {
        const state = false;
        this.changeSwitcherState(config, state);
        this.switchHiglightButtonOnCard(config, state);
        this.switchContent(config, state);
        this.config.stateData[config.name] = state;
        this.publishSettingsData();
        if (this.config.onHide instanceof Function) {
            this.config.onHide(this);
        }
    }

    publishSettingsData() {
        jQuery.event.trigger('userSettingsChanged.SETTINGS', this.config.stateData);
    }

    setState(stateData) {
        Object.keys(stateData)
            .filter(element => this.config[element])
            .forEach((element) => {
                if (stateData[element]) {
                    const checkbox = jQuery(this.config[element].switcherSelector);
                    this.show(this.config[element]);
                    checkbox.attr('checked', true);
                } else {
                    this.hide(this.config[element]);
                    if (this.config[element].name === 'showPrices') {
                        jQuery(this.config.priceHistory.switcherSelector)
                            .attr('disabled', true)
                            .closest('li')
                            .addClass(this.config.switcherInactiveClass);
                    }
                }
            });
    }

    changeSwitcherState(config, state) {
        const $switcher = jQuery(config.switcherSelector);
        if ($switcher.length) {
            if (state) {
                $switcher.parent().children().last().addClass(this.config.switcherActiveClass);
            } else {
                $switcher.parent().children().last().removeClass(this.config.switcherActiveClass);
            }
        }
    }

    switchHiglightButtonOnCard(config, state) {
        Array.from(jQuery(config.btnCardSelector)).forEach((element) => {
            const $currentElement = jQuery(element);
            const $runnerRow = $currentElement.closest(this.config.runnerRowSelector);
            const isActiveRunner = !$currentElement
                .hasClass(this.config.settingsButtonDisabledClass)
                && !$runnerRow.hasClass(this.config.nonRunnerClass)
                && !$runnerRow.hasClass(this.config.excludedRunnerClass);
            if (state && isActiveRunner) {
                $currentElement.addClass(config.btnCardActiveClass);
            } else {
                $currentElement.removeClass(config.btnCardActiveClass);
            }
        });
    }

    switchContent(config, state) {
        Array.from(jQuery(config.elementSelector)).forEach((element) => {
            const $currentElement = jQuery(element);
            const $runnerRow = $currentElement.closest(this.config.runnerRowSelector);
            const isActiveRunner = !$runnerRow.hasClass(this.config.nonRunnerClass)
                && !$runnerRow.hasClass(this.config.excludedRunnerClass);
            if (state && isActiveRunner) {
                $currentElement.removeClass(config.elementHiddenClass);
                if (config.elementShownClass) {
                    $currentElement.addClass(config.elementShownClass);
                }
            } else {
                $currentElement.addClass(config.elementHiddenClass);
                if (config.elementShownClass) {
                    $currentElement.removeClass(config.elementShownClass);
                }
            }
        });
        if (config.elementSelector === '.RC-notes') {
            autosize.update(jQuery(document).find('textarea'));
        }
    }

    dynamicPricesUpdated() {
        if (this.config.onInit instanceof Function) {
            this.config.onInit(this);
        }
    }

    trackCardCustomisation(stateData) {
        const traits = {
            [segmentio.TRAIT_RACE_CONDITIONS]: stateData.raceConditions ? 'On' : 'Off',
            [segmentio.TRAIT_FORM]: stateData.form ? 'On' : 'Off',
            [segmentio.TRAIT_MY_NOTES]: stateData.myNotes ? 'On' : 'Off',
            [segmentio.TRAIT_SPOTLIGHTS]: stateData.spotlights ? 'On' : 'Off',
            [segmentio.TRAIT_COMMENTS]: stateData.comments ? 'On' : 'Off',
            [segmentio.TRAIT_OWNER]: stateData.owner ? 'On' : 'Off',
            [segmentio.TRAIT_QUOTES]: stateData.quotes ? 'On' : 'Off',
            [segmentio.TRAIT_PEDIGREES]: stateData.pedigrees ? 'On' : 'Off',
            [segmentio.TRAIT_RTF]: stateData.rtf ? 'On' : 'Off',
            [segmentio.TRAIT_DECIMAL_ODDS]: stateData.decimalOdds ? 'On' : 'Off',
            [segmentio.TRAIT_PRICE_HISTORY]: stateData.priceHistory ? 'On' : 'Off',
            [segmentio.TRAIT_ORDER_BY_PRICE]: stateData.orderByPrice ? 'On' : 'Off',
            [segmentio.TRAIT_BETTING_FORCAST]: stateData.bettingForecast ? 'On' : 'Off',
            [segmentio.TRAIT_MY_RATINGS]: stateData.myRatings ? 'On' : 'Off',
            [segmentio.TRAIT_SHOW_PRICES]: stateData.showPrices ? 'On' : 'Off',
            [segmentio.TRAIT_LOCATION]: jQuery('[data-site-sub-section-2]').attr('data-site-sub-section-2'),
            [segmentio.TRAIT_RACE_ID]: jQuery('[data-site-sub-section-1]').attr('data-card-race-id'),
            [segmentio.TRAIT_RACE_DATE]: jQuery('.js-RC-watchLiveButton').attr('data-race-date'),
            [segmentio.TRAIT_RACE_TIME]: jQuery('[data-site-sub-section-1]').attr('data-card-race-time'),
            [segmentio.TRAIT_LAST_CHANGED_OPTION]: defaultConfig.lastChangedOption,
            [segmentio.TRAIT_RACECOURSE]: jQuery('[data-site-sub-section-1]').attr('data-card-coursename'),
        };
        segmentio.trackCardCustomisation(traits);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/customizeSettings/customizeSettings.js